import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
// import Button from '@mui/material/Button';

// for hours
import moments from "moment";
import "./ProjectsDetails.scss";
// for timepicker
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Loading from "../GeneralComponents/Loading";
import ScanQR from "./ScanQR/ScanQR";
import QRcodeIcon from "../../assets/images/qrcode-scan.svg";
import HandWrite from "../../assets/images/hand-write.svg";
import RefreshIcon from "../../assets/images/refresh-icon.svg";

// notification sound
import notificationSoundURL from "../../assets/sounds/notification.mp3";
import LoginInDialog from "../Login/LoginInDialog";
import Axios from "middleware/axiosInstance";
import { convertTimeToStandartTime } from "functions/functions";

const ProjectsDetails = () => {
  const [resultOfSearchInItemName, setResultOfSearchInItemName] = useState([]);
  // check if authentication is expired
  const [authenticationIsExpired, setAuthenticationIsExpired] = useState(null);

  const inputRefSearchItemName = useRef();
  const inputRefSearchResult = useRef();
  const inputRefItemName = useRef();
  const inputRefItemUnit = useRef();
  const inputRefItemValue = useRef("");
  // for routing
  const navigate = useNavigate();

  // show / hide QR Reader
  const [showQRreader, setShowQRreader] = useState(false);
  // const [allQRcodes, setAllQRcodes] = useState([])
  const [indexOfDetectedItemWithQRscaner, setIndexOfDetectedItemWithQRscaner] =
    useState();
  // is offline mode - its show projects submit is in online or offline mode
  const [isOfflineMode, setIsOfflineMode] = useState();
  const [isEditingMode, setIsEditingMode] = useState();
  const apiToken = localStorage.getItem("token");

  // current project info
  const [project, setProject] = useState();
  // categories items
  const [categories, setCateguries] = useState([]);
  // subCategories items
  const [categoryItems, setCategoryItems] = useState([]);

  const [itemUnits, setItemUnits] = useState([]);
  const [description, setDescription] = useState(null);

  // temporary selected items
  const [fieldInfo, setFieldInfo] = useState({
    itemName: null,
    itemValue: null,
    itemUnit: null,
    itemId: null,
  });

  // items selected(used for project)
  const [items, setItems] = useState(
    sessionStorage.getItem("projectItems") == null
      ? []
      : JSON.parse(sessionStorage.getItem("projectItems"))
  );
  const [distance, setDistance] = useState(null);

  // start project time
  const [startTime, setStartTime] = useState(null);
  // end project time
  const [endTime, setEndTime] = useState(null);

  // get query string to call project details
  const { search } = useLocation();

  useEffect(() => {
    // get query string from URL
    const UrlParams = queryString.parse(search);
    // start set state isOfflineMode
    UrlParams.offlineMode === "true"
      ? setIsOfflineMode(true)
      : setIsOfflineMode(false);
    UrlParams.editingMode === "true"
      ? setIsEditingMode({
          status: true,
          reportId: UrlParams.reportId,
        })
      : setIsEditingMode(false);
    // end set state isOfflineMode
    // start save project id to sessionstorage
    sessionStorage.setItem("project-id", UrlParams.projectId);
    // end save project id to sessionstorage

    // setProject and categories in offline mode
    if (UrlParams.offlineMode === "true") {
      // start setProject in offline mode
      const allLocalSavedProjects = JSON.parse(
        localStorage.getItem("offline-projects-list")
      );
      const indexOfSelectdProject = allLocalSavedProjects.findIndex(
        (project) => project.id === UrlParams.projectId
      );
      setProject([allLocalSavedProjects[indexOfSelectdProject]]);
      // end setProject in offline mode

      // start setCateguries in online mode
      const allLocalSavedCategories = JSON.parse(
        localStorage.getItem("offline-categories-list")
      );
      setCateguries(allLocalSavedCategories);

      // start get item units to use in select option
      const allLocalSavedItemUnits = JSON.parse(
        localStorage.getItem("offline-items-units")
      );
      setItemUnits(allLocalSavedItemUnits);

      // set QR codes
      // const allLocalQRCode = JSON.parse(localStorage.getItem('QRcodes-of-items'))
      // setAllQRcodes(allLocalQRCode)
    }

    // setProject and categories in online mode
    else {
      // start setProject in online mode
      Axios.get(`projects?employer=${UrlParams.employer}`)
        .then((response) => {
          setProject(response.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
      // end setProject in online mode

      // ****** start setCateguries in online mode ******
      // Axios.get(`subcategories`).then(async response => {
      //     const Data = response.data.data
      // remove two categories from list that unsuable
      // try {
      // 1) remove aghlame daray barcode
      // let IndexOfBarcodeCategory = await Data.findIndex(element => element.id == 39)
      // await Data.splice(IndexOfBarcodeCategory, 1)
      // 2) remove aghlame bedune barcode
      // let IndexOfAghlameBeduneBarcode = await Data.findIndex(element => element.id == 40)
      // await Data.splice(IndexOfAghlameBeduneBarcode, 1)
      // } finally {
      // setCateguries(Data)
      // }
      // }).catch(err => console.log(err))
      // ****** end setCateguries in online mode ******

      // start get item units to use in select option
      Axios.get(`itypes/itemstypes`)
        .then((response) => {
          setItemUnits(response.data.data);
        })
        .catch((err) => {
          console.log(err);
          alert("واحد های اندازه گیری از سرور دریافت نشد!");
        });
      // end get item units to use in select option

      // get all item to show and user can search in it
      getAllItem();
    }
  }, []);

  const getAllItem = () => {
    Axios.post(
      `all-item`,
      { api_token: apiToken },
      { Accept: "application/json" }
    )
      .then((response) => {
        setCategoryItems(response.data.data);
        setResultOfSearchInItemName(response.data.data);
      })
      .catch((error) => {
        // console.log(error.response.data.message)
        error.response.status == 401
          ? setAuthenticationIsExpired(true)
          : alert("عملیات انجام نشد!");
      });
  };

  const handleSelectCategory = (e) => {
    // let index = e.target.selectedIndex;
    // let element = e.target.childNodes[index]
    // let categoryId = element.getAttribute('id');
    // const apiRoute = `projects/${categoryId}`
    // if (isOfflineMode) {
    //     const getOfflineCategoryItems = JSON.parse(localStorage.getItem(`offline-subcategory-items-by-id`))
    //     // this syntax is ok for next line
    //     setCategoryItems(getOfflineCategoryItems[categoryId])
    //     // this syntax is ok for next line
    //     setResultOfSearchInItemName(getOfflineCategoryItems[categoryId])
    // }
    // else {
    // Axios.post(`${apiRoute}`, { api_token: apiToken }, { 'Accept': 'application/json' })
    // .then((response) => {
    //     setCategoryItems(response.data.data)
    //     setResultOfSearchInItemName(response.data.data)
    // })
    // .catch((error) => {
    //     // console.log(error.response.data.message)
    //     error.response.status == 401 ? setAuthenticationIsExpired(true) : alert("عملیات انجام نشد!")
    // })
    // }
  };

  const searchInItemName = (e) => {
    setFieldInfo({ ...fieldInfo, itemName: null });
    inputRefSearchItemName.current.value = e.target.value;
    const temp = [];
    categoryItems.forEach((item) => {
      if (item.name.includes(`${e.target.value}`)) {
        temp.push(item);
      }
    });
    setResultOfSearchInItemName(temp);
  };

  const handleSelectItemFromSearchResulte = (e) => {
    inputRefItemUnit.current.focus();
    const value = e.target.dataset.value;
    const id = e.target.id;
    setFieldInfo({ ...fieldInfo, itemId: id, itemName: value });
    setResultOfSearchInItemName(categoryItems);
    // inputRefSearchResult.current.style.display = "none !important";
    console.log(e);
    // inputRefItemUnit.getInputDOMNode().focus();
  };
  const handleSelectItemCategory = (e) => {
    let index = e.target.selectedIndex;
    let element = e.target.childNodes[index];
    let categoryId = element.getAttribute("id");
    // set value of an item
    const value = e.target.value;
    const name = e.target.name;
    setFieldInfo({ ...fieldInfo, itemId: categoryId, [name]: value });
  };
  // for all input to add to fieldInfo
  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setFieldInfo({ ...fieldInfo, [name]: value });
  };
  // add item to list and clear value field
  const addItemToList = () => {
    setItems([...items, fieldInfo]);
  };
  const handleAddItem = (e) => {
    e.preventDefault();
    const IsExist = items.findIndex(
      (item) => item.itemName === fieldInfo.itemName
    );
    IsExist == -1
      ? addItemToList()
      : alert(`${fieldInfo.itemName} قبلا ثبت شده است`);
    // indexOfDetectedItemWithQRscaner == null ? null : inputRefItemName.current.value = ""
    inputRefItemUnit.current.value = "";
    inputRefItemValue.current.value = "";
    // if inputRefSearchItemName exist(search box enable)
    try {
      inputRefSearchItemName.current.value = null;
      // if inputRefItemName exist(search box desable and options enable)
    } catch {
      inputRefItemName.current.value = null;
    }
    setFieldInfo({
      itemName: null,
      itemValue: null,
      itemUnit: null,
      itemId: null,
    });
    setIndexOfDetectedItemWithQRscaner();
  };
  const handleRemoveItem = (selectedItem) => {
    const temp = items.filter(
      (item) => item.itemName !== selectedItem.itemName
    );
    setItems(temp);
  };
  // set start time of project
  const handleStartDateChange = (date) => {
    setStartTime(date);
  };
  // set end time of project
  const handleEndDateChange = (date) => {
    setEndTime(date);
  };
  const saveToSessionStorage = () => {
    const convertStartTimeToStandard = convertTimeToStandartTime(startTime);
    const convertEndTimeToStandard = convertTimeToStandartTime(endTime);
    sessionStorage.setItem("start-time", convertStartTimeToStandard);
    sessionStorage.setItem("end-time", convertEndTimeToStandard);
    sessionStorage.setItem("employer-name", project[0].employer);
    isOfflineMode && sessionStorage.setItem("distance", `${distance} کیلومتر`);
  };
  // set items to session storage
  const setItemToSessionStorage = () => {
    if (startTime == null || endTime == null) {
      alert("ثبت ساعت شروع و پایان پروژه الزامی می باشد");
    } else {
      const convertStartTimeToStandard = convertTimeToStandartTime(startTime);
      const convertEndTimeToStandard = convertTimeToStandartTime(endTime);
      if (startTime.getTime() > endTime.getTime()) {
        alert("ساعت شروع و پایان پروژه جابجا هستند");
      } else if (convertStartTimeToStandard == convertEndTimeToStandard) {
        alert("ساعت شروع و پایان پروژه نمی توانند یکی باشند");
      } else {
        saveDescription();
        saveToSessionStorage();
        sessionStorage.setItem("projectItems", JSON.stringify(items));
        isOfflineMode === true
          ? sessionStorage.setItem("is-offline-mode", true)
          : sessionStorage.setItem("is-offline-mode", false);
        isOfflineMode === true
          ? navigate("/projects/signature")
          : navigate("/projects/map");
      }
    }
  };

  // const setDescription = (e) => {
  //     sessionStorage.setItem('description', e.target.value)
  // }
  const saveDescription = () => {
    sessionStorage.setItem("description", description);
  };

  // start QRCode reader component
  const handleErrorScanQRcode = () => {
    setShowQRreader(false);
    alert("دسترسی به دوربین مسدود شده است");
  };
  const rescanQRCode = (e) => {
    e.preventDefault();
    setShowQRreader(true);
    setIndexOfDetectedItemWithQRscaner();
  };

  const handleScanQRcode = (data) => {
    if (data) {
      // start vibrate and play notification sound
      navigator.vibrate(200);
      const audio = new Audio(notificationSoundURL);
      audio.play();
      // end vibrate and play notification sound

      setShowQRreader(false);
      // const DetectedItem = allQRcodes.find(item => item.name == data)
      // start check detected QRcode is valid
      // if (DetectedItem == undefined) {
      //     setIndexOfDetectedItemWithQRscaner()
      //     setTimeout(() => {
      //         alert("این بارکد در اقلام سامانه ثبت نشده است!")
      //     }, 1);
      // }
      // else {
      //     const DetectedItem = allQRcodes.find(item => item.name == data)
      //     const indexOfDetectedItem = allQRcodes.findIndex(item => item.name == data)
      // setIndexOfDetectedItemWithQRscaner(indexOfDetectedItem)
      setIndexOfDetectedItemWithQRscaner(data);
      setFieldInfo({
        ...fieldInfo,
        itemId: "item from Barcode scanner",
        itemName: data,
      });
      // }
      // end check detected QRcode is valid
    }
  };
  // end QRCode reader component

  // check all fielld is true to go next section
  const fieldInfoIsTrue =
    fieldInfo.itemName && fieldInfo.itemValue && fieldInfo.itemUnit;
  const fieldsAndDistanceIsTrue = isOfflineMode
    ? items.length >= 1 && distance / 1 > 0
    : items.length >= 1;
  // if in edit project report mode,  send data to server for editing project report
  const editReportHandler = () => {
    console.log(items);
    let convertStartTimeToStandard = null;
    let convertEndTimeToStandard = null;
    if (startTime !== null && endTime !== null) {
      convertStartTimeToStandard = convertTimeToStandartTime(startTime);
      convertEndTimeToStandard = convertTimeToStandartTime(endTime);
      if (startTime.getTime() > endTime.getTime()) {
        alert("ساعت شروع و پایان پروژه جابجا هستند");
      } else if (convertStartTimeToStandard == convertEndTimeToStandard) {
        alert("ساعت شروع و پایان پروژه نمی توانند یکی باشند");
      }
    }
    const startTimeInStandardFormat = convertStartTimeToStandard;
    const endTimeInStandardFormat = convertEndTimeToStandard;

    SendEditedItemsToServer(startTimeInStandardFormat, endTimeInStandardFormat);
  };
  const SendEditedItemsToServer = (start, end) => {
    const used_items = [];
    const units = [];
    const used_values = [];
    const editedData = {};
    if (items.length > 0) {
      try {
        // used_items' => 'nullable', 'string',
        // 'units' => 'nullable', 'string',
        // 'used_values' => 'nullable', 'string'
        items.forEach((item, index) => {
          used_items[index] = item.itemName;
          units[index] = item.itemUnit;
          used_values[index] = item.itemValue;
        });
        editedData.used_items = used_items;
        editedData.units = units;
        editedData.used_values = used_values;
      } catch {
        alert("در اقلام مشکلی پیش آمده");
      }
    }
    if (start !== null && end !== null) {
      editedData.start_time = start;
      editedData.end_time = end;
    }
    if (description !== null) {
      editedData.description = description;
    }
    editedData.api_token = apiToken;

    Axios.put(`edititems/projreport/${isEditingMode.reportId}`, editedData, {
      Accept: "application/json",
    })
      .then((res) => {
        if (res.success === true) {
          alert("ویرایش انجام شد!");
          navigate("/projects");
        }
      })
      .catch((error) => {
        // console.log(error.response.data.message)
        error.response.status == 401
          ? setAuthenticationIsExpired(true)
          : alert("ویرایش ثبت نشد!");
      });
  };
  return (
    <div className="main-container d-flex align-items-center flex-column">
      {isOfflineMode && (
        <div>
          <h3 className="mt-4 mb-n4" style={{ color: "red" }}>
            درحالت ثبت پروژه، به صورت آفلاین هستید!
          </h3>
        </div>
      )}

      {project ? (
        <div className="w-90">
          <div className="page-content-center mt-5">
            <h3>پروژه {project[0].employer}</h3>
          </div>

          <div className="time-picker-container">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <TimePicker
                clearable
                okLabel="تأیید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                label="ساعت شروع پروژه"
                value={startTime}
                onChange={handleStartDateChange}
                ampm={false}
                fullWidth
                minutesStep={5}
                onKeyDown={(event) => {
                  event.preventDefault();
                  return false;
                }}
              />

              <img
                className="qrcode-enable-disable-icon"
                src={showQRreader ? HandWrite : QRcodeIcon}
                onClick={() => setShowQRreader(!showQRreader)}
              />

              <TimePicker
                clearable
                okLabel="تأیید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                label="ساعت پایان پروژه"
                value={endTime}
                onChange={handleEndDateChange}
                ampm={false}
                fullWidth
                minutesStep={5}
                onKeyDown={(event) => {
                  event.preventDefault();
                  return false;
                }}
              />
            </MuiPickersUtilsProvider>
          </div>

          <div className="selection-container">
            {showQRreader && (
              <ScanQR
                handleError={handleErrorScanQRcode}
                onScan={handleScanQRcode}
              />
            )}
            {!showQRreader && indexOfDetectedItemWithQRscaner >= 0 ? (
              <div className="d-flex flex-row align-items-center justify-content-center">
                <p className="m-3">{[indexOfDetectedItemWithQRscaner].name}</p>
                <img
                  onClick={(e) => rescanQRCode(e)}
                  className="refresh-icon"
                  src={RefreshIcon}
                  alt="refresh-icon"
                />
              </div>
            ) : null}
            <form className={showQRreader ? "d-none" : "d-flex flex-column "}>
              {indexOfDetectedItemWithQRscaner == null ? (
                <>
                  {/* <select onChange={e => handleSelectCategory(e)} name="category"
                                        >
                                            <option value="" defaultValue hidden>انتخاب دسته ها</option>
                                            {categories.map((category, index) => {
                                                return (
                                                    <option id={category.id} value={category.name} key={index}>{category.name}</option>

                                                )
                                            })}
                                        </select> */}

                  {categoryItems.length > 15 ? (
                    <div className="search-container ">
                      <input
                        className="search-input"
                        value={fieldInfo.itemName && `${fieldInfo.itemName}`}
                        ref={inputRefSearchItemName}
                        placeholder={
                          (fieldInfo.itemName && `${fieldInfo.itemName}`) ||
                          "انتخاب اقلام"
                        }
                        type="text"
                        onChange={(e) => searchInItemName(e)}
                      />

                      {resultOfSearchInItemName.length > 0 && (
                        <div
                          className="search-result"
                          ref={inputRefSearchResult}
                        >
                          <ul>
                            {resultOfSearchInItemName.map((item) => {
                              return (
                                <li
                                  id={item.id}
                                  data-value={item.name}
                                  key={item.id}
                                  onClick={(e) =>
                                    handleSelectItemFromSearchResulte(e)
                                  }
                                >
                                  {item.name}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </div>
                  ) : (
                    <select
                      ref={inputRefItemName}
                      disabled={categoryItems.length <= 0}
                      onChange={(e) => handleSelectItemCategory(e)}
                      name="itemName"
                    >
                      <option value="" defaultValue selected="true">
                        انتخاب اقلام
                      </option>
                      {categoryItems.map((categoryItem, index) => {
                        return (
                          <option
                            id={categoryItem.id}
                            value={categoryItem.name}
                            key={index}
                          >
                            {categoryItem.name}
                          </option>
                        );
                      })}
                    </select>
                  )}
                </>
              ) : null}
              <select
                ref={inputRefItemUnit}
                onChange={(e) => handleInputChange(e)}
                name="itemUnit"
              >
                <option value="" defaultValue hidden>
                  واحد اندازه گیری
                </option>
                {itemUnits.map((unit, index) => {
                  return (
                    <option id="0" value={unit.itype}>
                      {unit.itype}
                    </option>
                  );
                })}
              </select>
              <input
                name="itemValue"
                maxLength="6"
                placeholder="تعداد"
                autoComplete="off"
                type="tel"
                onChange={(e) => handleInputChange(e)}
                ref={inputRefItemValue}
                onKeyUp={() => inputRefItemValue.current.value > 10 ? false : null}
                className=""
                // pattern="/\b([1-9]|[1-9][0-9])\b/g"
                // onKeyUp={() =>pattern="[A-Za-z]{3}" ? false : null}
              />
              <button
                className={
                  fieldInfoIsTrue
                    ? `custom-button-blue`
                    : `custom-button-disable`
                }
                disabled={!fieldInfoIsTrue}
                onClick={(e) => handleAddItem(e)}
              >
                {fieldInfoIsTrue ? `ثبت` : `لطفا موارد بالا را تکمیل کنید`}
              </button>
            </form>
          </div>
          <div className="cards-container my-4">
            {items.map((item, index) => {
              return (
                <div key={index} className="card mt-3">
                  <ul className="selected-items">
                    <li>{item.itemName}</li>
                    <li>
                      {item.itemValue} {item.itemUnit}
                    </li>
                  </ul>
                  <button
                    className="button-delete-item"
                    onClick={() => handleRemoveItem(item)}
                  >
                    حذف
                  </button>
                </div>
              );
            })}
          </div>

          <div className="d-flex justify-content-center flex-column">
            <textarea
              className="custom-textarea mt-4"
              onBlur={(e) => setDescription(e.target.value)}
              cols="30"
              rows="10"
              placeholder="لطفا شرح مختصری از اقدامات انجام شده را در این قسمت ثبت نمایید..."
            >
              {sessionStorage.getItem("description") == null
                ? null
                : sessionStorage.getItem("description")}
            </textarea>
            {/* if isOfflineMode we can't load map, so set distance in input manually */}
            {isOfflineMode && (
              <input
                type="tel"
                maxLength="6"
                className={`${
                  distance / 1 >= 0 ? null : "custom-textarea-empty"
                } custom-textarea mt-5`}
                placeholder="مسافت رفت تا پروژه بر حسب کیلومتر"
                // pattern="[0-9]{6}"
                onChange={(e) => setDistance(e.target.value)}
              />
            )}

            <button
              disabled={!fieldsAndDistanceIsTrue}
              // variant="contained"
              // color={fieldsAndDistanceIsTrue ? "success" : "error"}
              className={`my-5 ${
                fieldsAndDistanceIsTrue
                  ? `custom-button-blue`
                  : `custom-button-disable`
              }`}
              onClick={
                isEditingMode ? editReportHandler : setItemToSessionStorage
              }
            >
              {items.length > 0
                ? isOfflineMode
                  ? distance / 1 > 0
                    ? "ثبت اقلام"
                    : "فیلد مسافت اجباری است"
                  : isEditingMode
                  ? "ثبت ویرایش"
                  : "ثبت اقلام"
                : "اقلام را ثبت نمایید"}
            </button>
          </div>
        </div>
      ) : (
        <Loading />
      )}
      {authenticationIsExpired && <LoginInDialog />}
    </div>
  );
};
export default ProjectsDetails;
